import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function apiErrorMessage(err, fallback = "Something went wrong") {
  const status = err?.response?.status;
  const url = err?.config?.url;
  const d = err?.response?.data?.detail;
  // Iter 149 — Extraction order tuned to match the backend's actual error
  // shapes:
  //   * `HTTPException(422, detail={"code","message",...})` → object with
  //     .message (this project's convention, used by every explicit 4xx).
  //   * FastAPI Pydantic validation → array of {loc, msg, type}.
  //   * Older code paths may still use {msg:"..."} — kept as fallback.
  // NEVER `return String(d)` for an object: that renders "[object Object]".
  const base = (() => {
    if (!d) return err?.message || fallback;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e?.msg || e?.message || JSON.stringify(e)).join(" ");
    if (typeof d === "object") return d.message || d.msg || fallback;
    return String(d);
  })();
  if (status && status >= 400 && url) return `${base} · ${status} ${url}`;
  return base;
}
